<script>
  import { liteEloadCategoryMethods, liteEloadCategoryComputed, layoutMethods, exportMethods, erpFixMessages, erpUserRolesMethods, liteEloadDropdownMethods, liteEloadDropdownComputed } from '@/state/helpers';
  import Swal from 'sweetalert2';
  import ReorderModal from '@/components/ReorderModal.vue';
  import { required } from "vuelidate/lib/validators";
  import { getModuleAccess } from '@/router/helper.js'

  /**
   * Category Promo component
   */
  export default {
    page: {
      title: "Category Promo",
    },
    data() {
      return {
        title: "Category Promo",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 20, 30, 40, 50, 60, 70, 80, 90, 100],
        filter: null,
        filterOn: [],
        sortBy: null,
        sortDesc: false,
        submitted: false,
        fieldsCategory: [
          { key: 'category_name', label: 'Category Name', sortable: true, thClass: 'align-middle', tdClass: 'align-middle' },
          { key: 'network', label: 'Network', sortable: true, thClass: 'align-middle', tdClass: 'align-middle' },
          { key: 'status', label: 'Status', sortable: true, thClass: 'align-middle', tdClass: 'align-middle' },
          { key: 'item_count', label: 'Item Count', sortable: true, thClass: 'align-middle text-center', tdClass: 'align-middle text-center' },
          { key: 'hierarchy', label: 'Hierarchy', sortable: true, thClass: 'align-middle text-center', tdClass: 'p-0 align-middle text-center', thStyle: { backgroundColor: '#E6EAF1' }},
          { key: 'special', label: 'Special?', sortable: true, thClass: 'align-middle', tdClass: 'align-middle' },
          { key: 'duration', label: 'Duration (Days)', sortable: true, thClass: 'align-middle', tdClass: 'align-middle' },
          { key: 'icon', label: 'Icon', sortable: false, thClass: 'align-middle text-center', tdClass: 'align-middle text-center' },
          { key: 'color', label: 'Color', sortable: false, thClass: 'align-middle text-center', tdClass: 'align-middle text-center' }
        ],
        category_name: "",
        category_id:0,
        deleteCategoryName: "",
        itemsCategory: [],
        formExitChecker:"",
        searchValue: {
          searchField: null,
          search: "",
          sort: null,
          orderDesc: true,
          service: null,
          status: null,
          itemCount: null,
          special: null
        },
        searchListCategory: [
            { text: "Search All", value: null },
            { text: "Category Name", value: "name" }
          ],
        eloadServiceOptions: [{ text: "All", value: null }],
        statusOptions: [{ text: 'All', value: null }, { text: 'Active', value: '1' }, { text: 'Inactive', value: '0' }],
        itemCountOptions: [{ text: 'All', value: null }, { text: 'Zero (0)', value: 'zero' }, { text: 'Not zero (>0)', value: 'notzero' }],
        specialOptions: [{ text: 'All', value: null }, { text: 'Special', value: '1' }, { text: 'Not special', value: '0' }],
        eloadCategoryModule: {
          access: {
            create: true,
            delete: true
          }
        }
        ,
        // Reorder modal state
        showReorderModal: false,
        reorderTarget: {
          id: null,
          name: '',
          hierarchy: 1
        }
      };
    },
    components: {
      ReorderModal
    },
    validations:{
      category_name:{required}
    },
    computed: {
      ...liteEloadCategoryComputed,
      ...liteEloadDropdownComputed,
      ...erpFixMessages,
      rows() {
        return this.itemsCategory.length
      }
    },
    mounted: async function() {
      this.getCatList();
      this.changeTitle({title: 'E-Load Category'});
      this.changeBreadCrumb({
        breadCrumbs: [
          { text: 'Peddlr', to: { name: 'Home'}},
          { text: 'Peddlr Lite Manager', to: { name: 'Digital Load'} },
          { text: 'E-Load Category', to: { name: 'Category Promo'} }
        ]
      });
      try {
        await this.fetchLiteNetworksList();
        if (this.getLiteNetworksList && this.getLiteNetworksList.length > 0) {
          const sorted = (this.getLiteNetworksList || []).slice().sort((a, b) => {
            return String(a.name).localeCompare(String(b.name));
          });
          for (let c of sorted) {
            this.eloadServiceOptions.push({ text: c.name, value: c.id });
          }
        }
      } catch (e) {
        console.log("error while setup of parent category option", e);
      }

      // get the module access for checking if user has create, read, update, and/or delete access
      await getModuleAccess('Products', 'eLoad', 'eLoad Category')
      .then((access) => this.eloadCategoryModule.access = access);

    },
    methods: {
      ...layoutMethods,
      ...liteEloadCategoryMethods,
      ...liteEloadDropdownMethods,
      ...exportMethods,
      ...erpUserRolesMethods,
      showReorderDialog(item) {
        this.reorderTarget.id = item.id;
        this.reorderTarget.name = item.name || item.categoryName || '';
        this.reorderTarget.hierarchy = item.hierarchy || item.hierarchyOrder || item.order || 1;
        this.showReorderModal = true;
      },

      async handleReorderConfirm(newHierarchy) {
        // call API action 'reorder-category' with id and newHierarchy
        try {
          await this.actionLiteCategory({
            action: 'reorder-category',
            body: { id: this.reorderTarget.id.toString(), newHierarchy }
          });

          this.$toastV2.success('Category hierarchy updated successfully', 3000, 'bottom-right');


          this.showReorderModal = false;
          // refresh list
          this.getCatList();
        } catch (e) {
          console.error('reorder failed', e);
          Swal.fire({
            title: 'Update Failed!',
            text: this.resolveErrorMessage ? this.resolveErrorMessage(e) : 'Failed to reorder category',
            icon: 'error',
            confirmButtonColor: '#dc3545',
            customClass: { popup: 'swal-popup', confirmButton: 'btn btn-danger' }
          });
        }
      },

      handleReorderClose() {
        this.showReorderModal = false;
      },
      async onExport(){
        await this.onPageUpdate("reset");

        if (this.liteCategoryTotalRows == 0) {
          Swal.fire("Failed!", this.exportNullPrompt, "warning");
          return;
        }

        const params = Object.assign({}, this.searchValue, {
          email: JSON.parse(localStorage.getItem('userData')).email
        });

        // remove pagination params if present
        delete params.page;
        delete params.rows;

        this.actionLiteCategory({ action: 'export-category-list', body: params })
          .then(() => Swal.fire("Success!", `Your request for reports is pending. It will be sent to your email once it's ready.`, "success"))
          .catch(() => Swal.fire("Failed!", `Your request for reports has failed.`, "warning"));
      },
      async toggleCategoryStatus(item, event) {
        // ensure checkbox reflects current persisted state while deciding
        if (event && event.target) event.target.checked = item.status == 1;

        // Block toggling when a duration is set for special categories (but allow if expired)
        const hasDuration = item && item.isSpecial && item.durationDays;
        const isExpired = item.duration === 'Expired';
        
        if (hasDuration && !isExpired) {
          await Swal.fire({
            icon: 'info',
            title: 'Cannot Change Status',
            html: `Please clear the Duration field before changing the status. If the duration is set, it will automatically control the status based on the user-set duration.<br><br>
                        Once the duration starts, this category will become active, and when it ends, it will become inactive.`,
            confirmButtonText: 'OK',
            confirmButtonColor: '#6f42c1',
            customClass: {
              popup: 'swal-popup',
              confirmButton: 'btn btn-primary'
            }
          });
          return;
        }

        const currentStatus = item.status;
        const newStatus = currentStatus == 1 ? 0 : 1;
        const statusText = newStatus == 1 ? 'activate' : 'deactivate';

        Swal.fire({
          title: 'Are you sure?',
          text: `Do you really want to ${statusText} this category?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#6f42c1',
          cancelButtonColor: '#dc3545',
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          customClass: {
            popup: 'swal-popup',
            confirmButton: 'btn btn-primary px-4',
            cancelButton: 'btn btn-danger px-4'
          }
        }).then((result) => {
          if (result.isConfirmed) {
              // Prevent disabling when there are assigned SKUs (item_count > 0)
              const tryingToDisable = newStatus === 0;
              if (tryingToDisable && item && Number(item.itemCount) > 0) {
                Swal.fire({
                  icon: 'info',
                  title: 'Unable to Disable Category',
                  html: `This category cannot be disabled because there is an active SKU that is assigned and this category is currently in use.<br><br>Please move the SKU to another category before disabling this one.`,
                  confirmButtonText: 'OK',
                  confirmButtonColor: '#6f42c1',
                  customClass: { popup: 'swal-popup', confirmButton: 'btn btn-primary' }
                });
                // keep UI checkbox reflecting persisted state
                if (event && event.target) event.target.checked = item.status == 1;
                return;
              }

              this.actionLiteCategory({
                action: "toggle-category-status",
                body: {
                  id: item.id.toString(),
                }
              })
            .then((res) => {
              console.log("res", res);
              Swal.fire({
                title: 'Updated Successful!',
                text: `${item.name} is successfully ${statusText}d.`,
                icon: 'success',
                confirmButtonColor: '#6f42c1',
                confirmButtonText: 'OK',
                customClass: {
                  popup: 'swal-popup',
                  confirmButton: 'btn btn-primary'
                }
              });
              this.getCatList();
            }).catch((e) => {
              Swal.fire({
                title: 'Update Failed!',
                text: `An error occurred while updating the category status.`,
                icon: 'error',
                confirmButtonColor: '#dc3545',
                confirmButtonText: 'OK',
                customClass: {
                  popup: 'swal-popup',
                  confirmButton: 'btn btn-danger'
                }
              });
              console.log("error while updating category status", e);
            });
          }
        });
      },
      async getCatList() {
        await this.getLiteCategoryList({
          page: this.currentPage,
          rows: this.perPage,
          ...this.searchValue
        })
      },
      
      async onPageUpdate(reset = "") {
        if(reset == "reset"){
          this.currentPage = 1
        }
        await this.getCatList()
      },
      async onSearch() {
        this.currentPage = 1
        if (this.searchValue.search) {
          this.searching = true
        } else {
          this.searching = false
        }
        await this.getCatList()
      },
      eloadCategorySort(ctx){
        this.searchValue.sort = ctx.sortBy;
        this.searchValue.orderDesc = ctx.sortDesc;
        console.log(">> sorting",this.searchValue);
        if(this.prev_sort != ctx.sortBy){
          this.prev_sort = ctx.sortBy
          this.currentPage = 1
        }
        this.getCatList();
      },
      onDisplayChange(){
          console.log(this.liteCategoryTotalRows,this.perPage,this.liteCategoryList.length,(this.liteCategoryList.length < this.liteCategoryTotalRows && this.liteCategoryList.length != this.perPage));
        if(
          (this.liteCategoryList.length < this.liteCategoryTotalRows && this.liteCategoryList.length != this.perPage) || // condition for incrementing display per page
          (this.liteCategoryList.length == this.liteCategoryTotalRows && this.perPage < this.liteCategoryList.length) // condition for decreasing display per page
          ){
          this.onPageUpdate('reset')
        }
      },
      editCategory(item){
        console.log(">> EDIT:", item);
        this.$router.push(
          this.$route.query.redirectFrom || {
            name: "E-Load Lite Category Form", params: { id: item.id }
          }
        );
      },
      onRefresh() {
        this.searchValue = {
          searchField: null,
          search: "",
          sort: null,
          orderDesc: true,
          service: null,
          status: null,
          itemCount: null,
          special: null
        };
        this.sortBy = null;
        this.sortDesc = false;
        this.currentPage = 1;
        this.prev_sort = null;
        this.getCatList();
      },
    }
  }
    
</script>

<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <!-- Top bar: record count + action buttons -->
            <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
              <h5 class="card-title mb-0">
                <span class="fw-bold">{{liteCategoryTotalRows}}</span> Record(s)
              </h5>
              <div class="d-flex gap-2">
                <router-link v-if="eloadCategoryModule.access.create" :to="{ name: 'E-Load Lite Category Form', params: { id: 0 }}" class="tc-white">
                  <button class="btn btn-primary">
                    <i class="uil uil-plus me-1"></i> Category
                  </button>
                </router-link>
                <a class="btn btn-secondary" @click="onRefresh()">
                  <feather type="refresh-ccw" size="16" class="icon nav-icon"></feather>&nbsp; Refresh
                </a>
              </div>
            </div>

            <!-- Filter row 1: Search keyword + Status + Network + Item Count -->
            <div class="row g-2 align-items-end mb-2">
              <div class="col-md-5 col-sm-12">
                <div class="ta-right me-2">
                  <b-form-group description="Search Keyword">
                    <div class="d-flex">
                      <b-form-select
                        class="form-select rounded-0 rounded-start shadow-none flex-shrink-0"
                        style="width:fit-content"
                        v-model="searchValue.searchField"
                        :options="searchListCategory"
                      ></b-form-select>
                      <b-form-input
                        class="rounded-0 rounded-end"
                        v-model="searchValue.search"
                        @keyup.enter="onSearch()"
                      ></b-form-input>
                    </div>
                  </b-form-group>
                </div>
              </div>

              <div class="col-md-2 col-sm-6">
                <div class="ta-right me-2">
                  <b-form-group description="Filter by Status">
                    <b-form-select
                      class="form-select shadow-none"
                      v-model="searchValue.status"
                      :options="statusOptions"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="col-md-2 col-sm-6">
                <div class="ta-right me-2">
                  <b-form-group description="Filter by Network">
                    <b-form-select
                      class="form-select shadow-none"
                      v-model="searchValue.service"
                      :options="eloadServiceOptions"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>

              <div class="col-md-2 col-sm-5">
                <div class="ta-right me-2">
                  <b-form-group description="Filter by Item Count">
                    <b-form-select
                      class="form-select shadow-none"
                      v-model="searchValue.itemCount"
                      :options="itemCountOptions"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
            </div>

            <!-- Filter row 2: Special Category + Search + Export -->
            <div class="row g-2 align-items-start mb-4">
              <div class="col-md-3 col-sm-6">
                <div class="ta-right me-2">
                  <b-form-group description="Filter by Special Category">
                    <b-form-select
                      class="form-select shadow-none"
                      v-model="searchValue.special"
                      :options="specialOptions"
                    ></b-form-select>
                  </b-form-group>
                </div>
              </div>
              <div class="col-auto">
                <a class="btn btn-primary" @click="onPageUpdate('reset')">
                  <i class="bx bx-search bx-fw"></i> Search
                </a>
              </div>
              <div class="col-auto">
                <a class="btn btn-primary" href="javascript:void(0);" @click="onExport">
                  <i class="uil uil-export me-1"></i> Export
                </a>
              </div>
            </div>
            <!-- end row -->

            <!-- table responsive -->
            <div class="table-responsive">
              <div class="table align-middle table-nowrap">
                <b-table
                  :items="liteCategoryList"
                  :fields="fieldsCategory"
                  responsive="sm"
                  :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc"
                  :filter-included-fields="filterOn"
                  @sort-changed="eloadCategorySort"
                  :no-local-sorting="true"
                  table-class="align-middle"
                  class="table-check"
                >
                  <template #cell(category_name)="data">
                    <b-link
                      class="fw-medium"
                      @click="editCategory(data.item)"
                      >{{ data.item.name }}</b-link
                    >
                  </template>

                  <template #cell(network)="data">
                    <p class="text-body m-0">{{ data.item.network || data.item.networkName || '-' }}</p>
                  </template>

                  <template #cell(status)="data">
                    <div class="d-flex align-items-center">
                        <div class="form-check form-switch form-switch-md mb-0" dir="ltr">
                            <input
                                type="checkbox"
                                class="form-check-input"
                                :id="`statusSwitch_${data.item.id}`"
                                :checked="data.item.status == '0' ? false : true"
                                @change="toggleCategoryStatus(data.item, $event)"
                                :disabled="Number(data.item.default_category) === 1"
                            />
                            <label
                                class="form-check-label form-label small mb-0"
                                :class="data.item.status == '1' ? 'text-success' : 'text-muted'"
                                :for="`statusSwitch_${data.item.id}`"
                            >Active</label>
                        </div>
                    </div>
                  </template>
                  <template #cell(item_count)="data">
                    <span>{{data.item.itemCount}}</span>
                  </template>

                  <template #cell(hierarchy)="data">
                    <div @click.stop.prevent="showReorderDialog(data.item)" style="background:#E6EAF1; display:flex; align-items:center; justify-content:center; padding:0; min-height:56px; width:100%; cursor:pointer;">
                      <i class="mdi mdi-playlist-edit text-primary fs-2"></i>
                      <span class="ms-3">{{ data.item.hierarchy || data.item.hierarchyOrder || data.item.order || '-' }}</span>
                    </div>
                  </template>

                  <template #cell(special)="data">
                    <p class="text-body m-0">{{ (data.item.special === true || data.item.special == '1' || data.item.isSpecial) ? 'Yes' : 'No' }}</p>
                  </template>

                  <template #cell(duration)="data">
                    <p
                      class="text-body m-0"
                      :class="{ 'duration-expired': data.item.duration === 'Expired' }"
                    >{{ data.item.duration || '--' }}</p>
                  </template>

                  <template #cell(icon)="data">
                    <div class="text-center">
                      <img v-if="data.item.isSpecial" :src="data.item.iconUrl" alt="icon" style="height:22px;" />
                    </div>
                  </template>

                  <template #cell(color)="data">
                    <div class="text-center">
                      <span
                        v-if="data.item.isSpecial && data.item.color && data.item.color"
                        :style="{display:'inline-block', width:'14px', height:'14px', 'border-radius':'50%', background: data.item.color}"
                      ></span>
                    </div>
                  </template>
                </b-table>
              </div>
            </div>
            <!-- end table responsive -->
            <div class="row g-0 text-center" v-if="liteCategoryTotalRows == 0">
              <span>No data to display.</span>
            </div>
            <div class="row g-0 text-center text-sm-start" v-if="liteCategoryTotalRows != 0 && liteCategoryTotalRows > 10">
              <!-- end col -->
              <div class="col-sm-12">
                <div class="row">
                  <div class="col">
                    <div class="form-group row pull-left">
                      <label for="staticEmail" class="col-sm-6 col-form-label">Display:</label>
                      <div class="col-sm-6">
                        <b-form-group label-for="display-record">
                          <b-form-select class="form-select shadow-none w-fit"
                            id="display-record"
                            v-model="perPage"
                            :options="pageOptions"
                            @change="onDisplayChange()"
                          ></b-form-select>
                        </b-form-group>
                      </div>
                    </div>
                    <div
                      class="
                        dataTables_paginate
                        paging_simple_numbers
                        float-end
                      "
                      v-if="liteCategoryTotalRows > perPage"
                    >
                      <b-pagination
                        class="pagination-rounded"
                        v-model="currentPage"
                        @input="getCatList()"
                        :total-rows="liteCategoryTotalRows"
                        :per-page="perPage"
                      ></b-pagination>
                    </div>
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>

          </div>
          <!-- end card body -->
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- Reorder modal -->
    <ReorderModal
      :visible="showReorderModal"
      :category-name="reorderTarget.name"
      :current-hierarchy="reorderTarget.hierarchy"
      @confirm="handleReorderConfirm"
      @close="handleReorderClose"
    />
  </div>
</template>

<style>
.duration-expired {
  color: #C8C8C8 !important;
}
</style>